import { useEffect, useState } from "react"
import { useLocation, useNavigate, useParams } from "react-router-dom"

import { get } from "lodash-es"
import { ROUTES } from "src/App"

import useFetchEventDetails from "@fuse/pages/eventPage/useFetchEventDetails"
import { useBuyTicketsSession } from "@fuse/pages/eventSignUp/BuyTickets/buyTicketsSessionManager"

export const useStripeSuccess = () => {
  const params = useParams()
  const eventId = get(params, "eventId", "")
  const navigate = useNavigate()
  const location = useLocation()
  // const { state } = useLocation()

  const [show, setShow] = useState<boolean>(false)
  // const { state, refresh } = useFetchEventDetails(eventId)

  const currentEventDetails = get(location.state, "eventDetails", {})
  const flyerImage = get(currentEventDetails, "eventDocData.flyerImage", "")
  const eventName = get(currentEventDetails, "eventDocData.eventName", "-")

  const requiredApproval = get(location, "state.requiredApproval", false)
  const registrationType = get(location, "state.registrationType", "paid")
  const isFreeRegistration = registrationType === "free"

  const onContinueToEvent = async () => {
    navigate(ROUTES.EVENTS.replace(":eventId", eventId), {
      state: { from: "StripeCheckout" },
    })
  }

  const textToShow = {
    header: isFreeRegistration
      ? "Registration confirmed!"
      : requiredApproval
        ? "Ticket purchased successfully"
        : "You're in!",
    subTitle: isFreeRegistration
      ? `You've successfully registered for ${eventName}! The host has received your info and will keep you updated with all the details. Get ready for a great time!`
      : requiredApproval
        ? " Once you're approved by the host you'll have access to your ticket. You'll be refunded if not approved."
        : `You've successfully joined ${eventName}! The host has received your info and will keep you updated with all the details. Get ready for a great time!`,
  }

  const { clearAllBuyTicketsSession } = useBuyTicketsSession()

  useEffect(() => {
    clearAllBuyTicketsSession()
    const timer = setTimeout(() => setShow(true), 1000) // Hide after 3 seconds
    return () => clearTimeout(timer) // Cleanup timer
  }, [])

  return {
    show,
    flyerImage,
    onContinueToEvent,
    textToShow,
  }
}
